
import './App.css';
import {BrowserRouter, Routes, Route } from 'react-router-dom';
import Starter from "./components/pages/starter/Starter";
import TestQuiz from './components/pages/test-quiz/TestQuiz';
import Table from './components/pages/table/Table';
import Quiz from './components/pages/quiz/Quiz';
import Word from './components/pages/word/Word';
import MatchingGaps from './components/pages/matching-gaps/MatchingGaps';
import Sett from './components/pages/set/Sett';
import useTelegram from './hooks/useTelegram';
import { useEffect, useState } from 'react';
import Game from './components/pages/game/Game';
import TestList from './components/pages/tests/TestList';
import GuestTestList from './components/pages/tests/GuestTestList';

function App() {
  const { isTelegram, getUserId } = useTelegram();
  const [tgUserId, setTgUserId] = useState(null);

  useEffect(() => {
    if (isTelegram) {
      const userId = getUserId();
      if (userId) {
        setTgUserId(userId);
      } else {
        console.warn("Brak ID użytkownika Telegrama!");
      }
    }
  }, [isTelegram]);

  return (
    <div className="App">
      <div className='layout'>

      
      <BrowserRouter >
        <Routes >
          {  tgUserId?
              ( 
              <>
                  <Route  index path='/game' element={<Game tgUserId={tgUserId} />}/>
                  <Route path='/tests/:id' element={<TestList/>}/>
                  <Route path='/public-tests/:id' element={<GuestTestList/>}/>
                  <Route path='/test' element={<TestQuiz/>}/>
                  
                </>
              ):(
              <>
                  <Route index  element={<Starter />}/>
                  <Route path='/start' element={<Starter/>}/>
                  <Route path='/test' element={<TestQuiz/>}/>
                  <Route path='/grid' element={<Table/>}/>
                  <Route path='/quiz' element={<Quiz/>}/>
                  <Route path='/word' element={<Word/>}/>
                  <Route path='/matching-gaps' element={<MatchingGaps/>}/>
                  <Route path='/set' element={<Sett/>}/> 
              </>
              )
           
           }
                 
        </Routes>
       </BrowserRouter>
       </div>
    </div>
  );
}

export default App;
